import {
  ItemIdDocument,
  ItemPageBaseDocument,
  InvalidateItemPageDataDocument,
  CurrentItemDocument,
  UserRelatedItemDocument,
  ReportReasonsDocument
} from '../../graphql/graphql';

// Direct Document imports — avoid graphql() helper which pulls the full
// non-tree-shakeable operations map from graphql/gql.ts into the client bundle.
export const getItemId = ItemIdDocument;
export const getItemPage = ItemPageBaseDocument;
export const invalidateItemPageData = InvalidateItemPageDataDocument;
export const getCurrentItem = CurrentItemDocument;
export const getUserRelatedItem = UserRelatedItemDocument;
export const getReportReasonsQuery = ReportReasonsDocument;
